import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { golf } from './enums';

/**
 * Render VIP information if required.
 * @public
 * @param {props} props passed properties to function
 * @returns {React.ReactElement|Null} The VIP component
 */
export function VIP({ details }) {
  if (typeof details !== 'object' || !details) {
    return null;
  }

  return (
    <div className='shopper-vip'>
      <div className='shopper-vip-label'>
        <FormattedMessage id={ golf.vip } />
      </div>
      <div className='shopper-vip-details'>
        <div>
          { details.repname }
        </div>
        <div>
          Call:
          <a href={ `tel:${ details.phone }` }>
            { ` ${ details.phone }` }
          </a>
        </div>
        Email:
        <a href={ `mailto:${ details.email }` }>
          { ` ${ details.email }` }
        </a>
      </div>
    </div>
  );
}

VIP.propTypes = {
  details: PropTypes.object
};

export default VIP;
